import React, { useEffect, useState } from 'react';

import { apiBaseUrl } from '../../util/api';

import css from './ListingPage.module.css';

// Reviews about the shop, read from the migrated Firestore reviews (the stock
// Sharetribe reviews are empty on the firebase-catalog build).
const CatalogShopReviews = ({ shopId }) => {
  const [reviews, setReviews] = useState(null);

  useEffect(() => {
    if (!shopId) return;
    fetch(`${apiBaseUrl()}/api/catalog/shops/${encodeURIComponent(shopId)}/reviews`)
      .then(r => r.json())
      .then(data => setReviews(Array.isArray(data.reviews) ? data.reviews : []))
      .catch(() => setReviews([]));
  }, [shopId]);

  const count = reviews?.length || 0;

  return (
    <section id="reviews" className={css.sectionReviews}>
      <h2 className={css.sectionHeadingWithExtraMargin}>Reviews ({count})</h2>
      {reviews == null ? (
        <p className={css.catalogReviewEmpty}>Loading…</p>
      ) : count === 0 ? (
        <p className={css.catalogReviewEmpty}>No reviews yet.</p>
      ) : (
        <ul className={css.catalogReviewList}>
          {reviews.map((rev, i) => {
            const name = rev.authorName || 'Customer';
            const initials = name
              .split(/\s+/)
              .map(p => p.charAt(0))
              .join('')
              .slice(0, 2)
              .toUpperCase();
            const dateLabel = rev.createdAt
              ? new Date(rev.createdAt).toLocaleDateString('en-CA', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })
              : null;
            return (
            <li className={css.catalogReviewItem} key={i}>
              <div className={css.catalogReviewHead}>
                <span className={css.catalogReviewAvatar}>{initials}</span>
                <div className={css.catalogReviewHeadText}>
                  <span className={css.catalogReviewAuthor}>{name}</span>
                  <span className={css.catalogReviewMeta}>
                    {typeof rev.rating === 'number' ? (
                      <span className={css.catalogReviewStars}>
                        {'★'.repeat(Math.round(rev.rating))}
                        <span className={css.catalogReviewStarsDim}>
                          {'★'.repeat(Math.max(0, 5 - Math.round(rev.rating)))}
                        </span>
                      </span>
                    ) : null}
                    {dateLabel ? <span className={css.catalogReviewDate}>{dateLabel}</span> : null}
                  </span>
                </div>
              </div>
              {rev.content ? <p className={css.catalogReviewText}>{rev.content}</p> : null}
              {(rev.imageUrls && rev.imageUrls.length ? rev.imageUrls : rev.imageUrl ? [rev.imageUrl] : [])
                .length ? (
                <div className={css.catalogReviewImages}>
                  {(rev.imageUrls && rev.imageUrls.length ? rev.imageUrls : [rev.imageUrl]).map((img, j) => (
                    <a
                      className={css.catalogReviewImageLink}
                      href={img}
                      target="_blank"
                      rel="noreferrer"
                      key={j}
                    >
                      <img
                        className={css.catalogReviewImage}
                        src={img}
                        alt={`Photo from ${rev.authorName || 'a customer'}`}
                        loading="lazy"
                      />
                    </a>
                  ))}
                </div>
              ) : null}
            </li>
            );
          })}
        </ul>
      )}
    </section>
  );
};

export default CatalogShopReviews;
